import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import * as attachmentService from "../../../models/services/attachmentService";
import { IMessageListItem } from "source/models/message/messageListItem";
import { AttachmentList } from "source/components/attachments/AttachmentList/AttachmentList";
import downloadjs from "downloadjs";

interface IMessageListAttachmentsProps {
    item: IMessageListItem;
}

export const MessageListAttachments = ({ item }: IMessageListAttachmentsProps) => {
    const handleAttachmentDownload = async (id: string) => {
        if (!id) return;
        const attachment = item.attachments.find(i => i.id === id);
        if (!attachment) return;
        if (attachment.file) {
            downloadjs(attachment.file, attachment.name);
            return;
        }
        const fileName = await AppUtils.callService(() => attachmentService.getAttachment(id));
        if (!fileName) return;
        AppUtils.showSuccessMessage(String.format(Translations.AttachmentParameterDownloaded, fileName));
    };

    if (!item.attachments.length) return null;

    return (
        <AttachmentList
            isReadOnly={true}
            title={null}
            attachments={item.attachments}
            margin={"0.5rem 0 0 0"}
            direction="row"
            hideThumbnails={true}
            onRemoveAttachment={null}
            onDownloadAttachment={handleAttachmentDownload}
            onAddAttachments={null}
        />
    );
};
